// 重构的数据更新
export default {
  // 新增开始
  // 更新门店的tab
  updateCurrentTab(state, payload) {
    state.currentTab = payload
  },
  // 更新集合筛选项的筛选条件
  updateCondition(state, payload) {
    state.commonFilter = payload
  },
  // 更新门店列表所有筛选项的数据
  updateAllFilterParams(state, payload) {
    state.allFilterParams = payload
  },
  //
  updateCommonCityData(state, payload) {
    state.commonCityData = payload
  },
  // 首次默认城市数据更新
  updateCityIdWithAuth(state, payload) {
    state.cityIdsWithAuth = payload
  },
  // 更新通用三个tab城市商圈的数据
  updateCommonCityAreaTree(state, payload) {
    state.commnoCityAreaTree = payload
  },
  // 更新商圈tab下城市商圈的数据
  updateCityAreaTree(state, payload) {
    state.areaCityAreaTree = payload
  },
  // 更新其他三个tab选择的城市数据
  updateCommonCityChecked(state, payload) {
    const storageData = JSON.parse(localStorage.getItem('storageData')) || {}
    storageData.commonCityChecked = payload.value
    localStorage.setItem('storageData', JSON.stringify(storageData))
    state.commonCityChecked = payload
  },
  // 更新商圈tab城市选中的数据
  updateAreaCityChecked(state, payload) {
    const storageData = JSON.parse(localStorage.getItem('storageData')) || {}
    storageData.areaCityChecked = payload.value || ''
    localStorage.setItem('storageData', JSON.stringify(storageData))
    state.areaCityChecked = payload
  },
  updateAreaChecked(state, payload = []) {
    const storageData = JSON.parse(localStorage.getItem('storageData')) || {}
    storageData.areaChecked = payload
    localStorage.setItem('storageData', JSON.stringify(storageData))
    state.areaChecked = payload
  },
  // 更新其他三个tab选中商圈的数据
  updateCommonAreaChecked(state, payload = []) {
    const storageData = JSON.parse(localStorage.getItem('storageData')) || {}
    storageData.commonAreaChecked = payload
    localStorage.setItem('storageData', JSON.stringify(storageData))
    state.commonAreaChecked = payload
  },
  // 更新列表数据
  updateCommonList(state, payload) {
    const { currentTab, data, pageNo, reset } = payload
    state.storeInfo[currentTab].listData = reset
      ? data.list || []
      : state.storeInfo[currentTab].listData.concat(data.list || [])
    state.storeInfo[currentTab].total = data.total || 0
    state.storeInfo[currentTab].pageNo = pageNo || 1
  },
  updateStrategyTagFromWorkbench(state, payload) {
    state.strategyTagFromWorkbench = payload
  },
  // 新增结束
  updateInProcessList(state, payload) {
    state.inProcessList = payload
  },
  updateSuccessList(state, payload) {
    state.successList = payload
  },
  updateFailedList(state, payload) {
    state.failedList = payload
  },
  updateCategoryList(state, payload) {
    state.categoryList = payload
  },
  updatePlatformList(state, payload) {
    state.platformList = payload
  },
  updateBizoppDetail(state, payload) {
    state.details = Object.assign(state.details, payload)
  },
  updateSalesNameData(state, payload) {
    state.salesNameData = payload
  },
  // 销售姓名选中数量
  updateSalesNameNum(state, payload) {
    state.salesNameNum = payload
  },
  updateStrategyTag(state, payload) {
    state.strategyTagData = payload
  },
  // 销售姓名面包屑层级
  updateBreadCrumbList(state, payload) {
    if (payload) {
      state.breadCrumbList.push(payload)
    } else {
      state.breadCrumbList = []
    }
  },
  // 销售姓名选择面包屑
  updateBreadCrumbChange(state, payload) {
    if (payload.index !== state.breadCrumbList.length - 1) {
      state.breadCrumbList.splice(
        state.breadCrumbList.indexOf(payload.value) + 1
      )
    }
  },
  updateHomeFilterNum(state, payload) {
    let { name, num } = payload
    state['selectNum' + name] = num
  },

  // 重构V1门店列表新的筛选项更新
  updateStoreListFilter(state, payload) {
    state.storeListFilter = payload
  },
  // 改变状态
  changeShopZIndex(state, data) {
    state.changeZIndex = data
  },
  // 更新诊断
  updateDiagnosis(state, data) {
    state.diagnosis = Object.assign(
      {},
      {
        [data.shopId]: data.data
      }
    )
  },
  // 搜索历史
  updateHistory(state, data) {
    state.changeHistory = data
  },
  updateFirstEnterList(state, payload) {
    state.firstEnterList = payload
  }
}
